/**
 * app.module.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Provider } from "@angular/core";

/* tslint:disable:ordered-imports */

// ======== EXTERNAL MODULES ========
/**
 * External modules (browser & forms) and dependencies.
 */
import { BootstrapModalModule } from "angular2-modal/plugins/bootstrap";
import { BrowserModule } from "@angular/platform-browser";
import { ModalModule } from "angular2-modal";
import { NgModule } from "@angular/core";

// ======== INTERNAL MODULES / ROOT COMPONENT ========
/**
 * Internal modules, both eager- and lazy-loaded, as well as the bootstrapped
 * root component for this module.
 */
import { AggregationModule } from "./aggregation/aggregation.module";
import { SharedModule } from "./shared/shared.module";
import { CoreModule } from "./core/core.module";
import { MCPApplicationComponent } from "./mcp-application.component";

// TODO: Move into AdminModule
// This is challenging because it isn't clear how to configure the ModalModule
// for non-root modules or how to bind the modal anchor correctly. Until that's
// figured out, I'm leaving it here so that it sticks out like a sore thumb
// (rather than putting it into CoreModule with the other modals where it will
// get lost)
import { AdminChatModalComponent }
    from "./administration/admin-chat-modal.component";
import { ManagementModule } from "./management/management.module";

/**
 * The {@link AppModule} is the main chunk of the application. It gets
 * bootstrapped by the entry script, and it in turn contains references to all
 * of the main components and services needed by the application.
 */
@NgModule({
    imports: [
        BrowserModule,
        CoreModule,
        SharedModule,
        ManagementModule,
        AggregationModule.forRoot(),
        ModalModule.forRoot(),
        BootstrapModalModule,
    ],
    declarations: [ MCPApplicationComponent, AdminChatModalComponent ],
    bootstrap: [ MCPApplicationComponent ],
    entryComponents: [ AdminChatModalComponent ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/app.module.ts